module.exports = __webpack_public_path__ + "static/media/ni.pictogram.612ffd3a.svg";